import { render, staticRenderFns } from "./EventBasicsForm.vue?vue&type=template&id=711603a5&scoped=true"
import script from "./EventBasicsForm.vue?vue&type=script&lang=js"
export * from "./EventBasicsForm.vue?vue&type=script&lang=js"
import style0 from "./EventBasicsForm.vue?vue&type=style&index=0&id=711603a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711603a5",
  null
  
)

export default component.exports